export default "__VITE_ASSET__CSm5yKBR__"